import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProgressBar from "react-bootstrap/ProgressBar";
import { FaDownload, FaCheckDouble } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "./ObjectiveCheckIn.css";

function ObjectiveCheckIn({
  checkIn,
  handleDownloadEvidence,
  handleShowValidation,
  objectiveUserId,
  approverId,
  currentUserId,
  language,
}) {
  const dayjs = require("dayjs");

  const { t } = useTranslation();

  const selectCheckInStatusClass = (status) => {
    switch (status) {
      case "on-track":
        return "on-track-status-label";
      case "cautious":
        return "cautious-status-label";
      case "at-risk":
        return "at-risk-status-label";
      default:
        return "on-track-label";
    }
  };

  const selectCheckInStatusText = (status, language) => {
    let text = "";
    switch (status) {
      case "on-track":
        if (language === "en") {
          text = "On Track";
        } else if (language === "es") {
          text = "En curso";
        }
        return text;
      case "cautious":
        if (language === "en") {
          text = "Cautious";
        } else if (language === "es") {
          text = "Atención";
        }
        return text;
      case "at-risk":
        if (language === "en") {
          text = "At risk";
        } else if (language === "es") {
          text = "En riesgo";
        }
        return text;
      default:
        if (language === "en") {
          text = "On Track";
        } else if (language === "es") {
          text = "En curso";
        }
        return text;
    }
  };

  const selectProgressBarClass = (checkInStatus) => {
    switch (checkInStatus) {
      case "on-track":
        return "progress-bar-onTrack";
      case "cautious":
        return "progress-bar-cautious";
      case "at-risk":
        return "progress-bar-atRisk";
      default:
        return "progress-bar-onTrack";
    }
  };

  return (
    <Col>
      <Row className="no-margin">
        <Col className="right mb-2 icons-menu">
          {checkIn.evidence !== "" &&
          (approverId === currentUserId ||
            objectiveUserId === currentUserId) ? (
            <span
              className="icon-menu-item"
              onClick={() => handleDownloadEvidence(checkIn.evidence)}
            >
              <FaDownload />
            </span>
          ) : (
            <></>
          )}
          {checkIn.acknowledgment === false && approverId === currentUserId ? (
            <span
              className="icon-menu-item"
              onClick={() =>
                handleShowValidation(
                  checkIn._id,
                  checkIn.progress,
                  checkIn.created_at,
                )
              }
            >
              <FaCheckDouble />
            </span>
          ) : (
            <></>
          )}
        </Col>
      </Row>
      <Row className="no-margin">
        <Col className="last-checkin">
          <Row className="justify-content-center align-items-center mb-2">
            <Col lg={6}>
              <p className="lastCheckinDate">
                {dayjs(checkIn.created_at).format("D-MMM-YYYY")}
              </p>
            </Col>
            <Col lg={6} className="right">
              <span className={selectCheckInStatusClass(checkIn.checkInStatus)}>
                {selectCheckInStatusText(checkIn.checkInStatus, language)}
              </span>
            </Col>
          </Row>
          <Row className="justify-content-center align-items-center">
            <Col lg={12} className="mt-2">
              <ProgressBar
                className={selectProgressBarClass(checkIn.checkInStatus)}
                now={checkIn.progress}
                label={`${checkIn.progress}%`}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Col>
                <p className="lastCheckinNote">
                  <span className="strong">{t("Objetivos.User")}:</span>{" "}
                  {checkIn.note}
                </p>
              </Col>
              <Col>
                <p className="lastCheckinNote">
                  <span className="strong">{t("Objetivos.Jefe")}:</span>{" "}
                  {checkIn.validationNote}
                </p>
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
}

export default ObjectiveCheckIn;
